import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Hero from '../Hero';
import SummaryCards from '../Home/SummaryCards';
import About from '../About';
import ProfessionalJourney from '../ProfessionalJourney';
import Projects from '../Projects';
import LifeAndInterests from '../BehindResume';
import ContactSection from '../../Components/ContactSection';

import { personalData } from '../../data/profilePersonalData';
import { experiences } from '../../data/profileExperience';
import { educations } from '../../data/profileEdu';

import html from '../../Assets/html.svg';
import css from '../../Assets/css.svg';
import js from '../../Assets/javascript.svg';
import react from '../../Assets/react.svg';
import microsoft from '../../Assets/microsoftoffice.svg';
import tailwind from '../../Assets/tailwind.svg';
import python from '../../Assets/python.svg';
import fastapi from '../../Assets/fastapi.svg';
import figma from '../../Assets/figma.svg';
import matlab from '../../Assets/matlab.svg';
import numpy from '../../Assets/numpy.svg';
import pandas from '../../Assets/pandas.svg';
import postgresql from '../../Assets/postgresql.svg';

const Home = () => {
  useEffect(() => {
    AOS.init({ once: true, duration: 800 });
  }, []);

  const skillsData = [
    { name: 'HTML', icon: html },
    { name: 'CSS', icon: css },
    { name: 'JavaScript', icon: js },
    { name: 'React', icon: react },
    { name: 'Tailwind', icon: tailwind },
    { name: 'Microsoft Office', icon: microsoft },
    { name: 'Python', icon: python },
    { name: 'FastAPI', icon: fastapi },
    { name: 'Numpy', icon: numpy },
    { name: 'Pandas', icon: pandas },
    { name: 'Matlab', icon: matlab },
    { name: 'PostgreSQL', icon: postgresql },
    { name: 'Figma', icon: figma },
  ];

  const lifeStories = [
    {
      title: 'Biohacking: Optimizing my Body',
      description: 'I track everything—sleep with Oura, recovery with Whoop, macros down to the gram. Cold exposure, supplementation, memory games, neural optimization. I\'m not chasing "perfect." I\'m testing what\'s actually possible when you treat your biology like a system you can improve.',
      image: null,
    },
    {
      title: 'Bodybuilding: Discipline in Motion',
      description: '365 lb squat. 245 lb bench. Thousands of hours of showing up when I didn\'t feel like it. I\'m not trying to be a pro—I just love the process. This is the only body I get, and taking care of it is non-negotiable.',
      image: null,
    },
    {
      title: 'Football: FC Barcelona & the Beautiful Game',
      description: 'Die-hard FC Barcelona fan. Rafael Márquez was my idol growing up—first Mexican to lift the Champions League. Now I watch every match and argue tactics with anyone who\'ll listen. Pedri\'s my current favorite. Football isn\'t just a sport—it\'s a shared language across borders and cultures.',
      image: null,
    },
    {
      title: 'Learning: 100+ Books a Year',
      description: 'I read obsessively—finance, neuroscience, philosophy, history, politics. 300 books, papers and docs during my Bachelor\'s alone. I\'ve taken Stanford genetic engineering courses for fun and gone down neuroplasticity rabbit holes at 2 AM. Learning is how I make sense of the world.',
      image: null,
    },
    {
      title: 'Traveling: 30+ Countries and Counting',
      description: '30+ countries— to understand how people think and live in different contexts. Street food in Hungary, museums in Italy, family traditions in Brazil. Every place challenges my assumptions and expands what I think is possible.',
      image: null,
    },
  ];

  return (
    <div className="dark:bg-[#0d1224] bg-slate-50 dark:text-gray-100 text-slate-900 min-h-screen w-full relative overflow-x-hidden transition-colors duration-300">
      <main className="flex flex-col items-center px-4 md:px-10 lg:px-16 w-full max-w-screen-xl mx-auto space-y-32 pb-20">
        <Hero personalData={personalData} />
        <SummaryCards />
        <About personalData={personalData} skillsData={skillsData} />
        <ProfessionalJourney experiences={experiences} educations={educations} />
        <Projects />
        <LifeAndInterests lifeStories={lifeStories} />
        <ContactSection />
      </main>
    </div>
  );
};

export default Home;
